import { render, staticRenderFns } from "./TradeBoxV2.vue?vue&type=template&id=0e94e318&"
import script from "./TradeBoxV2.vue?vue&type=script&lang=js&"
export * from "./TradeBoxV2.vue?vue&type=script&lang=js&"
import style0 from "./TradeBoxV2.vue?vue&type=style&index=0&id=0e94e318&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports